import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {HEIMDALL_LOCAL_STORAGE_KEY} from "~/utilities/constants";
import {clearImpersonationSession} from "~/utilities/impersonationSession";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/sign-out")({
    loader: async ({context}) => {
        localStorage.removeItem(HEIMDALL_LOCAL_STORAGE_KEY);
        clearImpersonationSession();

        // Redirect to orcus's end_session endpoint so it can clear the HttpOnly
        // _session / _session.sig cookies server-side, then come back home.
        const logoutUrl = new URL("/oauth/logout", context.oidcAuthorizeBaseUrl);
        logoutUrl.searchParams.set("client_id", context.oidcClientId);
        logoutUrl.searchParams.set("post_logout_redirect_uri", `${window.location.origin}/`);
        window.location.href = logoutUrl.toString();

        // TODO: Revisit this
        // Suspend navigation while the hard redirect above takes effect.
        return new Promise(() => {});
    },
    errorComponent: ErrorComponent,
    notFoundComponent: NotFoundComponent,
    pendingComponent: PendingComponent,
});
